import React from 'react'
import Header from '../../headerone/Main'
import Breadcrumb from '../../Breadcrumb/Main'
import NationalScholarshipPortalEle from './NationalScholarshipPortalEle'


function Main() {
    return (
        <>
            <Header />
            <Breadcrumb title="Home" subtitle="Scholarship" />
            <NationalScholarshipPortalEle />
        </>
    )
}

export default Main